import { Disclosure } from "@headlessui/react";
import { Fragment } from "react";
import { Icon } from "../../../../../core/components/atoms/Icon";
import { Typography } from "../../../../../core/components/molecules/Typography";
import { useFilterConfigStore } from "../../../stores/filterConfig";
import InnerCheckbox from "../../exercises/components/innerCheckbox";

interface IAnotherContentFilter {
  contentType: string | number;
}

const AnotherContentFilter: React.FC<IAnotherContentFilter> = ({ contentType }) => {
  const { favorites, setFavorites, status, setStatus } = useFilterConfigStore();
  
  const StatusFilterLesson = () => (
    <Disclosure>
      {({ open }) => (
        <Fragment>
          <Disclosure.Button className='flex w-full justify-between text-left'>
            <Typography size='h4' type='title' className='text-left'>
              Status
            </Typography>
            <Icon
              Icon='expand_more'
              type='material'
              className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
            />
          </Disclosure.Button>
          <Disclosure.Panel className='flex w-full flex-col gap-xl pb-3 pl-4'>
            <InnerCheckbox
              onChange={() => setStatus('not_played')}
              label='Não assistidos'
              checked={status.includes('not_played')}
              id='status-not-played'
              value='not_played'
            />
            <InnerCheckbox
              onChange={() => setStatus('played')}
              label='Assistidos'
              checked={status.includes('played')}
              id='status-played'
              value='played'
            />
          </Disclosure.Panel>
        </Fragment>
      )}
    </Disclosure>
  )

  const StatusFilterMaterial = () => (
    <Disclosure>
      {({ open }) => (
        <Fragment>
          <Disclosure.Button className='flex w-full justify-between text-left'>
            <Typography size='h4' type='title' className='text-left'>
              Status
            </Typography>
            <Icon
              Icon='expand_more'
              type='material'
              className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
            />
          </Disclosure.Button>
          <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
            <InnerCheckbox
              onChange={() => setStatus('not_seen')}
              label='Não visualizados'
              checked={status.includes('not_seen')}
              id='status-not-seen'
              value='not_seen'
            />
            <InnerCheckbox
              onChange={() => setStatus('seen')}
              label='Visualizados'
              checked={status.includes('seen')}
              id='status-seen'
              value='seen'
            />
          </Disclosure.Panel>
        </Fragment>
      )}
    </Disclosure>
  )

  const StatusFilterPodcast = () => (
    <Disclosure>
      {({ open }) => (
        <Fragment>
          <Disclosure.Button className='flex w-full justify-between text-left'>
            <Typography size='h4' type='title' className='text-left'>
              Status
            </Typography>
            <Icon
              Icon='expand_more'
              type='material'
              className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
            />
          </Disclosure.Button>
          <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
            <InnerCheckbox
              onChange={() => setStatus('not_listened')}
              label='Não reproduzidos'
              checked={status.includes('not_listened')}
              id='status-not-listened'
              value='not_listened'
            />
            <InnerCheckbox
              onChange={() => setStatus('listened')}
              label='Reproduzidos'
              checked={status.includes('listened')}
              id='status-listened'
              value='listened'
            />
          </Disclosure.Panel>
        </Fragment>
      )}
    </Disclosure>
  )

  return (
    <Fragment>
      <InnerCheckbox
        onChange={() => setFavorites(!favorites)}
        label='Favoritos'
        checked={favorites}
        id='filter-favorites'
        value='favorites'
      />
      {(contentType === 'videoaula' || contentType === 0) && <StatusFilterLesson />}
      {(contentType === 'materiais' || contentType === 2) && <StatusFilterMaterial />}
      {(contentType === 'podcast' || contentType === 3) && <StatusFilterPodcast />}
    </Fragment>
  )
}

export default AnotherContentFilter;